export const yieldTask = (() => {
    // Node also has MessageChannel, but its port drains ~1000 queued messages
    // per event loop turn, so chained yields starve network I/O.
    if (typeof setImmediate === 'function') {
        return () => new Promise((resolve) => setImmediate(resolve));
    }
    // Browser: not clamped like setTimeout(0)
    if (typeof MessageChannel !== 'undefined') {
        const { port1, port2 } = new MessageChannel();
        const queue = [];
        port1.onmessage = () => {
            const fn = queue.shift();
            if (fn) {
                fn();
            }
        };
        return () => new Promise((resolve) => {
            queue.push(resolve);
            port2.postMessage(0);
        });
    }
    return () => new Promise((resolve) => setTimeout(resolve, 0));
})();
//# sourceMappingURL=schedule.js.map